import React, { createRef } from "react";
import { useSortBy, useTable, useBlockLayout, useResizeColumns } from "react-table";

export function BasicTable({columns, data, onClickRow} = {onClickRow: (idx, row) => {}}) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            autoResetSortBy: false,
        },
        useSortBy,
        useBlockLayout,
        useResizeColumns        
    )
    var maxHeaderLineCount = columns.map(column =>typeof column["Header"] == "string" ? column["Header"].split('\n').length : 1).reduce((a, b) => Math.max(a,b));
    // console.log(headerGroups);
    return (
        <table {...getTableProps()} className="ReactTable -highlight primary-pagination" style={{display: 'block', overflowX: 'scroll', whiteSpace: 'nowrap', WebkitOverflowScrolling: 'touch'}}>
            <thead className="rt-thead">
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr" style={{width:"100%"}}>
                        {headerGroup.headers.map((column,i) => (
                            <th {...column.getHeaderProps(column.isSortDisabled == true ? "" :column.getSortByToggleProps())}
                                className={"rt-th"+ (column.isSortDisabled == true ? " " : " -cursor-pointer ") +"text-center rt-resizable-header-content " +
                                    (column.isSorted
                                        ? column.isSortedDesc
                                            ? '-sort-desc '
                                            : '-sort-asc '
                                    : ' ')+(column.headerClassName ? column.headerClassName : "")}
                                style={{height: `${maxHeaderLineCount == 1 ? '100%' : (maxHeaderLineCount * 30 + 10) + 'px'}`, width: `${column.width + (column.headerLabel == '□' ? 10 : 0)}px`, minWidth: `${column.width + (column.headerLabel == '□' ? 10 : 0)}px`, maxWidth: `${column.width + (column.headerLabel == '□' ? 10 : 0)}px`}}>
                                {column.render('Header')}                                
                                <div {...column.getResizerProps()} 
                                className={"basic-table-header" + (columns[i].isResizing == false ? "" : " resizer isResizing " )} 
                                onClick={(e)=>{e.preventDefault();e.stopPropagation()}}
                                style={{whiteSpace: "pre"}}>
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()} className="rt-tbody" style={{display: 'table', width: '100%'}}>
                {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()} className={"rt-tr " + (data[i].rowColor ? data[i].rowColor : "")} style={{display: 'block'}} onClick={() => {onClickRow(i, row)}}>
                            {row.cells.map((cell, j) => {
                                return <td {...cell.getCellProps()} className={"rt-td " + (headerGroups[0].headers[j].headerLabel == '□' ? 'text-center' : '')+ (headerGroups[0].headers[j].className ? ' '+headerGroups[0].headers[j].className : '')} style={{width: `${headerGroups[0].headers[j].totalWidth + (headerGroups[0].headers[j].headerLabel == '□' ? 10 : 0)}px`, minWidth: `${headerGroups[0].headers[j].totalWidth + (headerGroups[0].headers[j].headerLabel == '□' ? 10 : 0)}px`, maxWidth: `${headerGroups[0].headers[j].totalWidth + (headerGroups[0].headers[j].headerLabel == '□' ? 10 : 0)}px`}}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}
